import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { BetVIP_Title } from '../../../../../utils/ES/Modals/SpotsModals';

const ModalBetvipSpot = () => {
  return (
    <>
      <ModalVideo
        id="spot-betvip"
        dataText={BetVIP_Title}
        videoSrc="https://player.vimeo.com/video/1208209193?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_BETVIP"
      />
    </>
  );
};

export default ModalBetvipSpot;
